import browserUpdate from 'browser-update';

const ErrorBoundaryFallback = () => {
    browserUpdate({
        required: {
            e: -4,
            f: -3,
            o: -3,
            s: -1,
            c: -1
        },
        insecure: true,
        unsupported: true,
        style: 'top',
        noclose: true,
    });

    return (
        <>
            <p style={{ marginLeft: '8px' }}>
                Sì è verificato un errore imprevisto.
                Il team tecnico è già stato informato.
            </p>
            <p style={{ marginLeft: '8px' }}>
                Ti invitiamo a riprovare più tardi.
            </p>
        </>
    );
};

export default ErrorBoundaryFallback;